import React, { Component } from 'react';
import { Col, Row, Card } from 'react-bootstrap';

import FormaDePago from './FormaDePago';
import Storage from '../../support/Storage';
import Loading from '../../facturotopia/loading/Loading';

class LicenseDetails extends Component {
  state = {}

  constructor(props) {
    super(props);

    this.state = {
      busy: true,
      data: {}
    };
  }

  async componentDidMount() {
    const data = await Storage.get('facturotopia');

    const { cliente } = data;
    const { metadata } = cliente;
    const { licencia } = metadata;

    this.setState({
      busy: false,
      data: {
        cliente: cliente,
        ...licencia
      }
    });
  }

  render() {
    const { data = {}, busy } = this.state;

    if (!!busy) {
      return <Loading className="text-info pl-3" />;
    }

    return (
      <>
        <Row>
          <Col>
            <h5>Mi licencia</h5>
          </Col>
        </Row>

        { !!data && (
          <div>
            <div className="d-block mt-3 mb-2">
              <strong className="text-muted">Detalles</strong>
            </div>

            <Card>
              <Card.Body>
                <Row>
                  <Col xs={ 6 } sm={ 4 } md={ 2 } lg={ 2 }>
                    <strong className="d-block text-info card-label-info">Producto: </strong>
                    <strong className="d-block text-info card-label-info">Periodicidad: </strong>
                    <strong className="d-block text-info card-label-info">Inicio de licencia: </strong>
                    <strong className="d-block text-info card-label-info">Próxima renovación: </strong>
                  </Col>

                  <Col xs={ 6 } sm={ 8 } md={ 10 } lg={ 10 }>
                    <span className="d-block">{ data.paquete }</span>
                    <span className="d-block">{ licencia(data) }</span>
                    <span className="d-block">{ data.licencia_inicio }</span>
                    <span className="d-block">{ data.licencia_fin }</span>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </div>
        )}

        <FormaDePago data={ data }/>
      </>
    );
  }
}

const licencia = (data) => {
  const { licencia } = data;

  let text = '';

  switch (licencia) {
    case 'y':
      text = 'Anual';
      break;

    case 'm':
      text = 'Mensual';
      break;

    default:
      break;
  }

  return <span>{ text }</span>
}

export default LicenseDetails;
